<div class="container-music-player">
  <div class="podcast">
    <div class="podcast-div">
      <a class="artwork" routerLink="/podcasts-web/episode/{{audioFile?.alias}}">
        <img
          [src]="audioFile?.thumbnail"
          alt="{{audioFile?.title}}">
      </a>
     
      <h3 class="podcast__episode_title">
        <span class="podcast_publisher">{{audioFile?.podcast_name}}</span><br/>
        <a style="color:#000" class="ep-title" routerLink="/podcasts-web/episode/{{audioFile?.alias}}">{{audioFile?.title}}</a></h3>
      <!-- <h5 class="podcast__title">
        Syntax.fm
        <i>Episode 152</i>
      </h5> -->
    </div>
    <div class="podcast__meta">
      <audio id="audio-ele" class="audio-ele" controls width="100%" autoplay>
        <source src="{{audioFile?.audio}}">
        Your browser does not support the audio tag.
      </audio>

    </div>
  </div>
</div>